import {
  CalendarOutlined,
  DropboxOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button, Modal, Spin, Timeline, Tooltip } from 'antd';
import React, { useState } from 'react';

import { useOrderShippingStatus } from '../../custom-hooks/sa-orders';
import { formatUTCTimeToLocal } from '../../utils/format';
import { StatusTimeline } from './OrderListing';
import { OrderOperationStatus } from './utils';

const OrderShipmentStatusTracking = ({
  record,
  onOpenChange,
}: {
  record: any;
  onOpenChange?: (open: boolean) => void;
}) => {
  const [visible, setVisible] = useState(false);

  const { isLoading, data } = useOrderShippingStatus(
    record.id,
    visible,
    record?.shipping_status_tracking || []
  );

  const generalLoading = isLoading || data?.loading;

  if (record?.operation_status !== OrderOperationStatus.PENDING_DELIVERY) {
    return null;
  }

  return (
    <>
      <Tooltip title="Delivery Status Tracking">
        <Button
          icon={<DropboxOutlined />}
          onClick={() => {
            // Close dropdown immediately when clicked
            onOpenChange?.(false);
            setVisible(true);
          }}
        >
          Shipment Status
        </Button>
      </Tooltip>
      <Modal
        title="Delivery Status Tracking"
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        width={600}
      >
        <Spin spinning={generalLoading}>
          <StatusTimeline>
            <Timeline>
              {(data?.tracking || []).map(statusObj => (
                <Timeline.Item
                  key={statusObj?.timestamp}
                  dot={<CalendarOutlined />}
                >
                  <strong>{statusObj?.next_status}</strong>
                  <span
                    style={{
                      display: 'block',
                      fontSize: '12px',
                      opacity: 0.8,
                      marginTop: 4,
                    }}
                  >
                    {formatUTCTimeToLocal(
                      statusObj?.timestamp,
                      'DD MMM YYYY, HH:mm (Z)'
                    )}
                  </span>
                  <div style={{ fontSize: '12px', marginTop: 2 }}>
                    <UserOutlined /> By {statusObj?.user_info?.full_name}
                  </div>
                </Timeline.Item>
              ))}
              {(!data?.tracking || data?.tracking.length === 0) && (
                <Timeline.Item>
                  <span style={{ opacity: 0.6 }}>
                    No shipment tracking data available
                  </span>
                </Timeline.Item>
              )}
            </Timeline>
          </StatusTimeline>
        </Spin>
      </Modal>
    </>
  );
};

export default OrderShipmentStatusTracking;
